import React, { FunctionComponent } from 'react'
import { Button, Heading, Modal, Icon, Text } from '@afterpaytouch/core'
import styles from './style.module.css'
import { useTranslation } from '../../utils/convergence'
import { Trans } from '../../utils/convergence'

interface IdentityVerificationTerminalErrorModalProps {
  showModal: boolean
  setShowModal: (bool: boolean) => void
}

export const IdentityVerificationTerminalErrorModal: FunctionComponent<IdentityVerificationTerminalErrorModalProps> = ({ showModal, setShowModal }) => {
  const { t } = useTranslation()

  const components = {
    bold: <strong />,
    br: <br />,
  }

  const closeModal = (): void => {
    setShowModal(false)
  }

  return (
    <Modal show={showModal}>
      <div className={styles.container}>
        <Modal.Header>
          <div className={styles.heading}>
            <div>
              <Button.Link
                type='button'
                size='Large'
                aria-label='identity-verification-terminal-error-back'
                testNameSpace='identity-verification-terminal-error-back'
                onClick={() => closeModal()}
              >
                <Icon.ArrowLeft size='Small' />
              </Button.Link>
            </div>
            <Heading size='XL'>{t('terminalError:identityVerificationDeclinedPCL.informationModal.heading')}</Heading>
          </div>
        </Modal.Header>
        <Modal.Content>
          <div className={styles.text}>
            <Text size='S'>
              <Trans i18nKey='terminalError:identityVerificationDeclinedPCL.informationModal.message' context={'1'} components={components} />
            </Text>
          </div>
          <div className={styles.text}>
            <Text size='S'>
              <Trans i18nKey='terminalError:identityVerificationDeclinedPCL.informationModal.message' context={'2'} components={components} />
            </Text>
          </div>
          <div className={styles.text}>
            <Text size='S'>
              <Trans i18nKey='terminalError:identityVerificationDeclinedPCL.informationModal.message' context={'3'} components={components} />
            </Text>
          </div>
          <div className={styles.text}>
            <Text size='S'>
              <Trans i18nKey='terminalError:identityVerificationDeclinedPCL.informationModal.message' context={'4'} components={components} />
            </Text>
          </div>
          <div className={styles.text}>
            <Text size='S'>
              <Trans i18nKey='terminalError:identityVerificationDeclinedPCL.informationModal.message' context={'5'} components={components} />
            </Text>
          </div>
        </Modal.Content>
      </div>
    </Modal>
  )
}
